import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { AppConfigService } from 'src/app/app-config/app-config-service';
import { getFileUrlFromToken, isFileUrl } from './file-url';

@Pipe({
    name: 'fileUrl',
    standalone: false
})
export class FileUrlPipe implements PipeTransform {
   filereaderUrl: string;

   constructor(private appConfig: AppConfigService) {
      this.filereaderUrl = `${appConfig.getConfig().filereaderUrl}`;
   }
   transform(value: string | SafeUrl | null): any {
      if (!value) {
         return null;
      }
      if (isFileUrl(value, this.filereaderUrl)) {
         return value;
      }

      return `${this.filereaderUrl}${getFileUrlFromToken(value as string)}`;
   }
}
